export var CurrencySymbols;
(function (CurrencySymbols) {
    CurrencySymbols["DOLLER_SYMBOL"] = "$";
    CurrencySymbols["EURO_SYMBOL"] = "\u20AC";
    CurrencySymbols["POUND_SYMBOL"] = "\u00A3";
})(CurrencySymbols || (CurrencySymbols = {}));
//# sourceMappingURL=CurrencySymbols.js.map